import { Typography } from '@rossum/ui/material';
import { OverviewGridRowModel } from '../../types/fields';

export const renderFieldId = ({
  value,
}: {
  value?: OverviewGridRowModel['fieldId'];
}) => (
  <Typography
    variant="subtitle2"
    color="text.secondary"
    sx={{ display: 'inline-block' }}
  >
    {value ?? 'No field Id'}
  </Typography>
);
